/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'platform.anonymous-asset-name.alligator': 'Anonymous Alligator',
  'platform.anonymous-asset-name.alpaca': 'Anonymous Alpaca',
  'platform.anonymous-asset-name.ape': 'Anonymous Ape',
  'platform.anonymous-asset-name.apple': 'Anonymous Apple',
  'platform.anonymous-asset-name.avocado': 'Anonymous Avocado',
  'platform.anonymous-asset-name.baboon': 'Anonymous Baboon',
  'platform.anonymous-asset-name.badger': 'Anonymous Badger',
  'platform.anonymous-asset-name.bat': 'Anonymous Bat',
  'platform.anonymous-asset-name.bear': 'Anonymous Bear',
  'platform.anonymous-asset-name.beaver': 'Anonymous Beaver',
  'platform.anonymous-asset-name.bee': 'Anonymous Bee',
  'platform.anonymous-asset-name.bird': 'Anonymous Bird',
  'platform.anonymous-asset-name.bison': 'Anonymous Bison',
  'platform.anonymous-asset-name.blobfish': 'Anonymous Blobfish',
  'platform.anonymous-asset-name.blossom': 'Anonymous Blossom',
  'platform.anonymous-asset-name.blowfish': 'Anonymous Blowfish',
  'platform.anonymous-asset-name.blueberries': 'Anonymous Blueberries',
  'platform.anonymous-asset-name.boar': 'Anonymous Boar',
  'platform.anonymous-asset-name.broccoli': 'Anonymous Broccoli',
  'platform.anonymous-asset-name.buffalo': 'Anonymous Buffalo',
  'platform.anonymous-asset-name.bug': 'Anonymous Bug',
  'platform.anonymous-asset-name.bull': 'Anonymous Bull',
  'platform.anonymous-asset-name.bunny': 'Anonymous Bunny',
  'platform.anonymous-asset-name.butterfly': 'Anonymous Butterfly',
  'platform.anonymous-asset-name.cactus': 'Anonymous Cactus',
  'platform.anonymous-asset-name.camel': 'Anonymous Camel',
  'platform.anonymous-asset-name.candy': 'Anonymous Candy',
  'platform.anonymous-asset-name.cantaloupe': 'Anonymous Cantaloupe',
  'platform.anonymous-asset-name.capsicum': 'Anonymous Capsicum',
  'platform.anonymous-asset-name.carrot': 'Anonymous Carrot',
  'platform.anonymous-asset-name.cat': 'Anonymous Cat',
  'platform.anonymous-asset-name.caterpiller': 'Anonymous Caterpiller',
  'platform.anonymous-asset-name.chameleon': 'Anonymous Chameleon',
  'platform.anonymous-asset-name.cherry': 'Anonymous Cherry',
  'platform.anonymous-asset-name.chili': 'Anonymous Chili',
  'platform.anonymous-asset-name.chimp': 'Anonymous Chimp',
  'platform.anonymous-asset-name.chimpanzee': 'Anonymous Chimpanzee',
  'platform.anonymous-asset-name.clover': 'Anonymous Clover',
  'platform.anonymous-asset-name.clownfish': 'Anonymous Clownfish',
  'platform.anonymous-asset-name.cobra': 'Anonymous Cobra',
  'platform.anonymous-asset-name.coconut': 'Anonymous Coconut',
  'platform.anonymous-asset-name.cod': 'Anonymous Cod',
  'platform.anonymous-asset-name.cookie': 'Anonymous Cookie',
  'platform.anonymous-asset-name.corn': 'Anonymous Corn',
  'platform.anonymous-asset-name.cow': 'Anonymous Cow',
  'platform.anonymous-asset-name.crab': 'Anonymous Crab',
  'platform.anonymous-asset-name.crocodile': 'Anonymous Crocodile',
  'platform.anonymous-asset-name.deer': 'Anonymous Deer',
  'platform.anonymous-asset-name.dinosaur': 'Anonymous Dinosaur',
  'platform.anonymous-asset-name.dodo': 'Anonymous Dodo',
  'platform.anonymous-asset-name.dog': 'Anonymous Dog',
  'platform.anonymous-asset-name.dolphin': 'Anonymous Dolphin',
  'platform.anonymous-asset-name.donut': 'Anonymous Donut',
  'platform.anonymous-asset-name.dragon': 'Anonymous Dragon',
  'platform.anonymous-asset-name.duck': 'Anonymous Duck',
  'platform.anonymous-asset-name.elephant': 'Anonymous Elephant',
  'platform.anonymous-asset-name.elk': 'Anonymous Elk',
  'platform.anonymous-asset-name.fish': 'Anonymous Fish',
  'platform.anonymous-asset-name.flamingo': 'Anonymous Flamingo',
  'platform.anonymous-asset-name.fox': 'Anonymous Fox',
  'platform.anonymous-asset-name.frog': 'Anonymous Frog',
  'platform.anonymous-asset-name.gecko': 'Anonymous Gecko',
  'platform.anonymous-asset-name.giraffe': 'Anonymous Giraffe',
  'platform.anonymous-asset-name.gorilla': 'Anonymous Gorilla',
  'platform.anonymous-asset-name.grape': 'Anonymous Grape',
  'platform.anonymous-asset-name.hammerhead': 'Anonymous Hammerhead',
  'platform.anonymous-asset-name.hedgehog': 'Anonymous Hedgehog',
  'platform.anonymous-asset-name.hippo': 'Anonymous Hippo',
  'platform.anonymous-asset-name.kangaroo': 'Anonymous Kangaroo',
  'platform.anonymous-asset-name.kitten': 'Anonymous Kitten',
  'platform.anonymous-asset-name.kiwi': 'Anonymous Kiwi',
  'platform.anonymous-asset-name.koala': 'Anonymous Koala',
  'platform.anonymous-asset-name.lemon': 'Anonymous Lemon',
  'platform.anonymous-asset-name.leopard': 'Anonymous Leopard',
  'platform.anonymous-asset-name.lettuce': 'Anonymous Lettuce',
  'platform.anonymous-asset-name.lion': 'Anonymous Lion',
  'platform.anonymous-asset-name.lizard': 'Anonymous Lizard',
  'platform.anonymous-asset-name.llama': 'Anonymous Llama',
  'platform.anonymous-asset-name.lobster': 'Anonymous Lobster',
  'platform.anonymous-asset-name.macaque': 'Anonymous Macaque',
  'platform.anonymous-asset-name.mango': 'Anonymous Mango',
  'platform.anonymous-asset-name.melon': 'Anonymous Melon',
  'platform.anonymous-asset-name.millipede': 'Anonymous Millipede',
  'platform.anonymous-asset-name.monkey': 'Anonymous Monkey',
  'platform.anonymous-asset-name.mouse': 'Anonymous Mouse',
  'platform.anonymous-asset-name.octopus': 'Anonymous Octopus',
  'platform.anonymous-asset-name.olive': 'Anonymous Olive',
  'platform.anonymous-asset-name.orange': 'Anonymous Orange',
  'platform.anonymous-asset-name.orangutan': 'Anonymous Orangutan',
  'platform.anonymous-asset-name.otter': 'Anonymous Otter',
  'platform.anonymous-asset-name.owl': 'Anonymous Owl',
  'platform.anonymous-asset-name.ox': 'Anonymous Ox',
  'platform.anonymous-asset-name.oyster': 'Anonymous Oyster',
  'platform.anonymous-asset-name.panda': 'Anonymous Panda',
  'platform.anonymous-asset-name.parrot': 'Anonymous Parrot',
  'platform.anonymous-asset-name.peacock': 'Anonymous Peacock',
  'platform.anonymous-asset-name.pear': 'Anonymous Pear',
  'platform.anonymous-asset-name.penguin': 'Anonymous Penguin',
  'platform.anonymous-asset-name.pig': 'Anonymous Pig',
  'platform.anonymous-asset-name.pineapple': 'Anonymous Pineapple',
  'platform.anonymous-asset-name.poodle': 'Anonymous Poodle',
  'platform.anonymous-asset-name.puppy': 'Anonymous Puppy',
  'platform.anonymous-asset-name.python': 'Anonymous Python',
  'platform.anonymous-asset-name.rabbit': 'Anonymous Rabbit',
  'platform.anonymous-asset-name.raccoon': 'Anonymous Raccoon',
  'platform.anonymous-asset-name.rat': 'Anonymous Rat',
  'platform.anonymous-asset-name.rhino': 'Anonymous Rhino',
  'platform.anonymous-asset-name.robot': 'Anonymous Robot',
  'platform.anonymous-asset-name.rose': 'Anonymous Rose',
  'platform.anonymous-asset-name.seal': 'Anonymous Seal',
  'platform.anonymous-asset-name.seedling': 'Anonymous Seedling',
  'platform.anonymous-asset-name.shark': 'Anonymous Shark',
  'platform.anonymous-asset-name.shrimp': 'Anonymous Shrimp',
  'platform.anonymous-asset-name.skunk': 'Anonymous Skunk',
  'platform.anonymous-asset-name.sloth': 'Anonymous Sloth',
  'platform.anonymous-asset-name.snail': 'Anonymous Snail',
  'platform.anonymous-asset-name.snake': 'Anonymous Snake',
  'platform.anonymous-asset-name.snowman': 'Anonymous Snowman',
  'platform.anonymous-asset-name.squid': 'Anonymous Squid',
  'platform.anonymous-asset-name.squirrel': 'Anonymous Squirrel',
  'platform.anonymous-asset-name.strawberry': 'Anonymous Strawberry',
  'platform.anonymous-asset-name.sunfish': 'Anonymous Sunfish',
  'platform.anonymous-asset-name.sunflower': 'Anonymous Sunflower',
  'platform.anonymous-asset-name.tiger': 'Anonymous Tiger',
  'platform.anonymous-asset-name.tomato': 'Anonymous Tomato',
  'platform.anonymous-asset-name.tortoise': 'Anonymous Tortoise',
  'platform.anonymous-asset-name.tree': 'Anonymous Tree',
  'platform.anonymous-asset-name.trex': 'Anonymous T-rex',
  'platform.anonymous-asset-name.trout': 'Anonymous Trout',
  'platform.anonymous-asset-name.turkey': 'Anonymous Turkey',
  'platform.anonymous-asset-name.turtle': 'Anonymous Turtle',
  'platform.anonymous-asset-name.wasp': 'Anonymous Wasp',
  'platform.anonymous-asset-name.watermelon': 'Anonymous Watermelon',
  'platform.anonymous-asset-name.whale': 'Anonymous Whale',
  'platform.anonymous-asset-name.wolf': 'Anonymous Wolf',
};
